import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
@Injectable()
export class ApiListService {
    public baseUrl = environment.APIEndpoint;


    public ucmsbaseUrl = 'https://ucmsapioffline.workplaceoptions.com/';
    // public WpobaseUrl = 'https://api.workplaceoptions.com/';
    // public WpobaseUrl = this.baseUrl+'wpo/';
    // public ContentbaseUrl = 'https://www.powerflexweb.com/';
    public ContentbaseUrl = this.baseUrl+'wpo/';
    public lyricBaseUrl = environment.lyricEndpoint;

    login = this.baseUrl + 'allyuser/user_login/';
    registration = this.baseUrl + 'salesforce/signupstep/';
    create = this.baseUrl + 'allyuser/createuser/';
    masterDropDown = this.baseUrl + 'helpers/dropdownmasterfaqs/'
    review = this.baseUrl + 'helpers/reviews/';
    myAccProfileImage = this.baseUrl + 'allyuser/updateprofilepic/';
    userProfile = this.baseUrl + 'allyuser/userprofile/';
    logOut = this.baseUrl + 'allyuser/user_logout/';
    userProgileUpdate = this.baseUrl + 'allyuser/profileupdate/';
    wallet = this.baseUrl + 'allyuser/createWalletCard/';
    fileupload = this.baseUrl + 'helpers/fileupload/';
    tokenupdate = this.baseUrl + 'mdlive/mdlive_login/';
    user_lifestyle = this.baseUrl + 'allyuser/user_lifestyle/';
    addFamailyMember = this.baseUrl + 'salesforce/creating_family/';
    authDeauth = this.baseUrl + 'allyuser/authorizeprimary/';
    ChangePassword = this.baseUrl + 'allyuser/change_password/';
    edocProviderList = this.baseUrl + 'helpers/care_provider_list/';
    postMessage = this.baseUrl + 'helpers/postMessage/';
    headerMessage = this.baseUrl + 'helpers/headerMessage/';
    indevisulalMessage = this.baseUrl + 'helpers/getMessage/?message_id='
    saveErrorLog = this.baseUrl + "allyadmin/save_errorlogs/"
    confirmationRating = this.baseUrl + "allyadmin/appointment_confirmation_rating/"
    verifyEmail = this.baseUrl + 'allyuser/verify_email/';
    verifyOtp = this.baseUrl + 'allyuser/verify_otp/';
    verifyUser = this.baseUrl + 'allyuser/verify_user/';
    getState = this.baseUrl + 'allyadmin/state_list/'
    getCity = this.baseUrl + 'allyadmin/state_record/?state='
    userverify = this.baseUrl + 'allyuser/userverify/';
    switchUser = this.baseUrl + 'allyuser/switch_user/';
    setPassword = this.baseUrl + 'allyuser/password_set/';
    registerPreenrolled = this.baseUrl + 'salesforce/pre_enrolled_dependent/';
    dependentDetail = this.baseUrl + 'salesforce/dependent_detail/';
    forgotpass = this.baseUrl + 'allyuser/forget_password/';
    setNewPassword = this.baseUrl + 'allyuser/forget_password_set/';
    forgotUsername = this.baseUrl + 'allyuser/forget_username/';
    emailNotificationUpdate = this.baseUrl + 'helpers/emailNotificationdetailview/';
    emailNotificationGet = this.baseUrl + 'helpers/emailNotificationlistview/';
    pushNotificationUpdate = this.baseUrl + 'helpers/pushNotificationdetailview/';
    pushNotificationget = this.baseUrl + 'helpers/pushNotificationlistview/';
    insuranceInformation = this.baseUrl + 'salesforce/insurance_info/';
    therapistData = this.baseUrl + 'mdlive/speciality_list/?provider_type=therapist';
    psychiatristData = this.baseUrl + 'mdlive/speciality_list/?provider_type=psychiatrist';
    helpSupport = this.baseUrl + 'salesforce/customer_support/';
    messageHelpSupport = this.baseUrl + 'salesforce/customer_support_conversation/';
    emailVerify = this.baseUrl + 'allyuser/email_verify/';
    scheduleAppointment = this.baseUrl + 'mdlive/scheduleappointment/';
    cancelAppointmentEmail = this.baseUrl + 'mdlive/cancelappointment/';
    readMessages = this.baseUrl + 'allyuser/readmessages/';
    cobranding = this.baseUrl + 'salesforce/cloneneworgassets/';
    deleteWalletCard = this.baseUrl + 'allyuser/createWalletCard/';
    medicalBillEmail = this.baseUrl + 'helpers/medicalbill/';
    reatTime = this.baseUrl + 'allyuser/realtime-user-verify/';
    latestMessage = this.baseUrl + 'salesforce/customer-support/message-count/';
    usernameVerifyUpdate = this.baseUrl + 'allyuser/usernameverify/';
    emailVerifyUpdate = this.baseUrl + 'allyuser/emailverify/';
    walletProviders = this.baseUrl + 'helpers/provider-type/providertype/';
    uploadWalletDoc = this.baseUrl + 'allyuser/wallet-card-doc/';

    updateFamilyById = this.baseUrl + 'salesforce/dependent/?dep_id=';
    updateFamilyByUserName = this.baseUrl + 'salesforce/dependent/?username=';
    sendEmail = this.baseUrl + 'allyuser/send_mailagent/'
    starRating = this.baseUrl + 'allyadmin/star_rating/'
    getRating = this.baseUrl + 'allyadmin/get_star_rating/'
    getCallMethod = this.baseUrl + 'allyadmin/get_call_method/'
    magicLink = this.baseUrl + 'allyuser/magic_link/'

    /********************MDlive************************* */


    public baseUrlMdlive = environment.APIEndpointMDLive
    imageBaseUrl = 'https://stage-rest-api.mdlive.com/api/v1';
    patient = this.baseUrlMdlive + 'patients/';
    patientV1 = this.baseUrlMdlive + 'patients/';
    userloginvarifaction = this.baseUrlMdlive + 'mobile_user_auth/auth_token/';
    chief_complaints = this.baseUrlMdlive + 'patients/chief_complaints?';
    documents = this.baseUrlMdlive + 'patients/';
    documents_v1 = this.baseUrlMdlive + 'patients/';
    documentsShow = this.baseUrlMdlive + 'patients/';
    upcomingAppointement = this.baseUrlMdlive + 'patients/';
    medical_conditions = this.baseUrlMdlive + 'patients/';
    madicationSerch = this.baseUrlMdlive + 'medications/search';
    allergiesSerch = this.baseUrlMdlive + 'allergies/search';
    clinical_concepts = this.baseUrlMdlive + 'clinical_concepts';
    surgery_names = this.baseUrlMdlive + 'surgery_names';
    get_dependant_types = this.baseUrlMdlive + 'patients/family_members/get_dependant_types';
    insurance_payers = this.baseUrlMdlive + 'insurance_payers';
    provider = this.baseUrlMdlive + 'providers/';
    provider_v1 = this.baseUrlMdlive + 'providers/';
    auth_extend = this.baseUrlMdlive + 'sso_auth/auth_extend';
    retrive_all_conversion_of_patient = this.baseUrlMdlive + 'patients/';
    retrive_message_of_doctor_patients = this.baseUrlMdlive + 'patients/';
    send_message = this.baseUrlMdlive + 'patients/';
    message_mark_read = this.baseUrlMdlive + 'patients/';
    checkPayment = this.baseUrlMdlive + 'payments/costs/check?patient_id='
    currentPharmacy = this.baseUrlMdlive + 'patients/';
    requestAppointment = this.baseUrlMdlive + 'patients/';
    cancelReqApp = this.baseUrlMdlive + 'patients/';
    remindReqApp = this.baseUrlMdlive + 'patients/';
    systemNotify = this.baseUrlMdlive + 'patients/';
    consultationSummary = this.baseUrlMdlive + 'patients/';
    updatePhoneNumber = this.baseUrlMdlive + 'patients/';
    switchAppointmentToPhone = this.baseUrlMdlive + 'patients/';
    deleteDocuments = this.baseUrlMdlive + "patients/"

    /****************************PCP FLOW********************************** */
    pcpPostUrl = this.baseUrlMdlive + 'patients/'
    searchPcp = this.baseUrlMdlive + 'health_systems/providers/pcp_search?'


    /**************************Video Calling*************************** */
    connection_params = this.baseUrlMdlive + 'appointments/';

    /**************************DDN************************************* */
    // ddnBaseUrl = 'https://api.discountdrugnetwork.com/api/';
    ddnBaseUrl = this.baseUrl+'wpo/';
    getDDNToken = this.ddnBaseUrl + 'auth/login/';
    searchDrug = this.ddnBaseUrl + 'Drug/Autocomplete';
    findDrugs = this.ddnBaseUrl + 'Drug/FindDrugs';
    drugFormStrength = this.ddnBaseUrl + 'Drug/DrugFormStrength';

    //newDesign for Tiles

    tileUrl = this.baseUrl + 'allyadmin/get_custom_tile/?account_id='
    tileSingleData = this.baseUrl + 'allyadmin/tile_details/'
    opportunityCost = this.baseUrl + 'allyadmin/opportunity_cost/?account_id='



    // ucms apis 

    // List of services 
    listOfService = this.ucmsbaseUrl + 'api/client/service'
    serviceRequest = this.ucmsbaseUrl + 'api/client/request/service'

    // wpo api 
    // wpoRegister = this.WpobaseUrl + 'api/SB/external/v1/Register/NewUser'

    contentCategories = this.ContentbaseUrl + 'common/read_mod.php'  
    featuredArticleList = this.ContentbaseUrl + 'common/read_ftr.php'
    recentArticleList = this.ContentbaseUrl + 'common/read_new.php'
    newForYou = this.ContentbaseUrl + 'common/read_nfy.php'
    TotalDataForFilter = this.ContentbaseUrl + 'common/read_cat.php'
    subcatrgories = this.ContentbaseUrl + 'common/read.php'
    searchArticle = this.ContentbaseUrl + 'common/read.php'
    
    detailsOfArticles = this.ContentbaseUrl + 'common/read_one.php'

    slack = this.baseUrl + 'allyadmin/save_errorlogs/'
    getBenefitCard = this.baseUrl + 'allyadmin/get_benifit_card/'


    // lyric 
    lyricHistory = this.baseUrl + 'lyrics/consultationHistory/getAllConsultations/?start=0&length=10&status=Complete'
    getActive = this.baseUrl + 'lyrics/consultation/getActive/'
    startConsultation = this.baseUrl + 'lyrics/consultation/'
    allergies = this.baseUrl + 'lyrics/medicationAllergies/?query='
    medications = this.baseUrl + 'lyrics/medication/?query='
    addAttachment = this.baseUrl + 'lyrics/attachment/add/'
    getPharmacy = this.baseUrl + 'lyrics/pharmacy/search/'
    lyricUrgentCareFaq = this.baseUrl + 'helpers/dropdownmasterfaqs/lyrictalktoadoctornow/'
    lyricOtherFaq = this.baseUrl + 'helpers/dropdownmasterfaqs/lyrictalktocounsellor/'
    getProvider = this.baseUrl + 'lyrics/consultation/availability/'
    createConsultation = this.baseUrl + 'lyrics/consultation/createConsultation/'
    memberCancel = this.baseUrl + 'lyrics/consultation/diagnostic/memberCancel/?ConsulationId='

    pushMessages = this.baseUrl + 'allyuser/pushmessages/'

    healthRecords = this.baseUrl + 'lyrics/healthRecords/'
    attachmentstream = this.baseUrl + 'lyrics/attachmentstream/?attachmentId='

    // createConsultation = this.lyricBaseUrl + '/consultation/createConsultation'
    // getActive = this.lyricBaseUrl + '/consultation/getActive'
    // healthRecords = this.lyricBaseUrl + '/healthRecords'
    // memberCancel = this.lyricBaseUrl + '/consultation/diagnostic/memberCancel'

    providerImage = this.baseUrl + 'lyrics/attachment/streamPhysicianProfile/inline'


    getCurrentPharmacy = this.baseUrl + 'lyrics/memberAccount/getPharmacy/'
    addPharmacy = this.baseUrl + 'lyrics/memberAccount/addPreferredPharmacy/'

    doctorNotePdf = this.baseUrl + 'lyrics/attachment/streamDoctorNote/?doctorNote_id='
    holidaylist = this.baseUrl + 'helpers/holidaylist/'
    deleteAttachment = this.baseUrl + 'lyrics/attachment/delete/'

    // message module lyric 
    addAskADoctorAttachment = this.baseUrl + 'lyrics/attachment/addAskADoctorAttachment'
    replyThread = this.baseUrl + 'lyrics/askADoctor/add'
    getThreads = this.baseUrl + 'lyrics/askADoctor?page='
    getMessage = this.baseUrl + 'lyrics/askADoctor/thread/'
    getStates = this.baseUrl + 'lyrics/states/all'

    otpSent = this.baseUrl + "allyuser/send_twilio_otp/"
    otpVerify = this.baseUrl + "allyuser/verify_twilio_otp/"
    
    endThread = this.baseUrl + "lyrics/askADoctor/endConversation/"



    // wpo wrapper api 
    newWpoRegister = this.baseUrl + "wpo/Register/NewUser"
    createwpodetails = this.baseUrl + "allyuser/crete_wpodetails/"

    getSpecialist = this.baseUrl + 'wpo/Specialist/Details'
    allSpecialistCon = this.baseUrl + 'wpo/AllSpecialistConversation/Details'
    closeSpecialist = this.baseUrl + 'wpo/CloseSpecialist/Conversation'
    replyToTheardWpo = this.baseUrl + 'wpo/AddSpecialist/Conversation'
    createNewTheard = this.baseUrl + 'wpo/AddSpecialist/Conversation'
    icyEligibility = this.baseUrl + 'wpo/CheckICYFeature/Eligibility'
    createVideoChat = this.baseUrl + 'wpo/CreateVideo/Chat'
    videoRequestStatus = this.baseUrl + 'wpo/UpdateIMVideoRequest/Status'

    downloadSummary = this.baseUrl + 'lyrics/consultationHistory/getAllConsultations/?'
   
    
    // wpo wrapper api 
    
    // https://allyhealth-back.theclientdemos.com/api/v3/
    // https://allyhealth-back.theclientdemos.com/api/v3/lyrics/attachment/streamPhysicianProfile/inline/?providerId=2509144
    // https://allyhealth-back.theclientdemos.com/api/v3/lyrics/attachment/streamPhysicianProfile/inline/?providerId=2509144
}